import { combineReducers } from 'redux';

import forumThreads from './forumThreads/reducer';

export default combineReducers({
  forumThreads
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/paging/reducer.js
 **/